export const convertErrorsNz = { INVALID: 'error', VALID: null };
